import { formatDuration } from 'date-fns';

import type { Duration, FormatDistanceToken, Locale } from 'date-fns';

const formatMap: Partial<Record<FormatDistanceToken, string>> = {
  xDays: 'd',
  xHours: 'hr',
  xMinutes: 'min',
  xSeconds: 'sec',
};

export const formatDurationConcise = (duration: Duration) => {
  if (!duration) return;

  const conciseLocale: Pick<Locale, 'formatDistance'> = {
    formatDistance: (token, count) => `${count} ${formatMap[token] ?? ''}`,
  };

  return formatDuration(duration, {
    format: ['days', 'hours', 'minutes', 'seconds'],
    locale: conciseLocale,
  });
};
